import React, { Component } from "react";
import { connect }          from "react-redux";
//IMPORT COMPONENT
import AppBar               from "material-ui/AppBar";
import IconButton           from "material-ui/IconButton";
import NavigationClose      from "material-ui/svg-icons/navigation/close";
import NavigationMenu       from "material-ui/svg-icons/navigation/menu";
import IconArrowBack        from "material-ui/svg-icons/navigation/arrow-back";
//ACTION
import { logout }           from "../Actions/Action_Authentication";
//UTILS
import * as ROLES           from "../Utils/Roles_Types";
import * as ROUTE           from "../Utils/Strings/Route";
import * as PAGESSWITCH     from "../Utils/PagesSwitch.js";
//ROUTER
import createBrowserHistory from "history/createBrowserHistory";
//MY COMPONENT
import Loader               from "../Components/component_Loader";
//IMPORT STYLE
import "../CSS/style_menu_min.css";
import "../CSS/style_menu_med.css";
import "../CSS/style_menu_max.css";
import "../CSS/style_menu_normalize.css";
//IMPORT ICON
import "../CSS/icon-font/icon-bilapp-complete/css/sg-bilapp.css";
import "../CSS/icon-font/icon-bilapp-complete/css/sg-bilapp-codes.css";
import "../CSS/icon-font/icon-bilapp-complete/css/sg-bilapp-embedded.css";
//LABELS
import { LABEL_PAGE_Company, LABEL_PAGE_Libra, LABEL_PAGE_CustomPrints, LABEL_PAGE_CustomPrintsA, LABEL_PAGE_Printer, LABEL_PAGE_CustomTables, LABEL_PAGE_CustomTablesA,
         LABEL_PAGE_CustomFields,LABEL_PAGE_CustomFieldsA, LABEL_PAGE_Librasm, LABEL_PAGE_Weigh, LABEL_Plant, LABEL_PAGE_Operators, LABEL_PAGE_Settings, LABEL_PAGE_Holding, LABEL_Logout,
         LABEL_Choose_Plant,LABEL_PAGE_Libras, LABEL_Payment, LABEL_PAGE_UpgradePro, LABEL_PAGE_UpgradeCloud } from "../Utils/Strings/Labels";

let history = createBrowserHistory();


class Menu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userInfo   :JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY)),
      role       : localStorage.getItem(ROLES.ROLES_KEY),
      menuOpened : false
    }
  }

  onLeftIconButtonClick = () => {
    if(this.props.backAddress)
      PAGESSWITCH.gotoPageWithParams(this.props.backAddress);
    this.setState({menuOpened : !this.state.menuOpened});
  }

  render() {

    var scaduto  = this.state.userInfo && (this.state.userInfo.Scadenza.Scaduto);
    var userFree = this.state.userInfo && (this.state.userInfo.Role.ID === ROLES.ACCOUNT_FREE_ID );
    var userPro  = this.state.userInfo && (this.state.userInfo.Role.ID === ROLES.ACCOUNT_PRO_ID  );
    var notProAndFree = !userFree && !userPro;
    var USERLANGUAGE = this.props.Language;

    var menuIcon = this.props.backAddress ? <IconArrowBack/> : this.state.menuOpened ? <NavigationClose/> : <NavigationMenu/>;
    return  <div>
          <AppBar className="app-bar-all" title={this.props.pageName} iconElementLeft={<IconButton
              >
                {menuIcon}
              </IconButton>} onLeftIconButtonClick={this.onLeftIconButtonClick} iconElementRight={this.props.rightNavButtonIcon && <IconButton
                >
                  {this.props.rightNavButtonIcon}
                </IconButton>} onRightIconButtonClick={this.props.rightNavButtonFunction} />

          <div className="container">
            <Loader isFetching={this.props.isFetching} />
            {/*<div className="title-header">
          <h1></h1>
  </div>*/}

            {this.state.menuOpened && this.props.backAddress == null && <ul className="icon-menu">
                  {!scaduto && <li className="icon-box home" onClick={() => {
                          PAGESSWITCH.gotoPageWithParams(ROUTE.Home);
                        }}>
                        <i className="fa icon-home-1 fa-4x" />
                        <a>
                          <h2>Home</h2>
                        </a>
                      </li>}

                  {!scaduto && <li className="icon-box home" onClick={() => {
                          PAGESSWITCH.gotoPageWithParams(ROUTE.Weigh);
                        }}>
                        <i className="fa icon-receipt fa-4x" />
                        <a>
                          <h2>{LABEL_PAGE_Weigh[USERLANGUAGE]}</h2>
                        </a>
                      </li>}

                  {!scaduto && <li className="icon-box home" onClick={() => {
                          PAGESSWITCH.gotoPageWithParams(ROUTE.Libras);
                        }}>
                        <i className="fa icon-balance-scale fa-4x" />
                        <a>
                          <h2>{LABEL_PAGE_Libras[USERLANGUAGE]}</h2>
                        </a>
                      </li>}

                  {!scaduto && <li className="icon-box home" onClick={() => {
                          PAGESSWITCH.gotoPageWithParams(ROUTE.Plants);
                        }}>
                        <i className="fa icon-building fa-4x" />
                        <a>
                          <h2>{LABEL_Plant[USERLANGUAGE]}</h2>
                        </a>
                      </li>}

                  {//Le aziende sono visualizzabili solo da amministratore IS e holding
                  (this.state.role === ROLES.ADMINISTRATOR_IS_ID || this.state.role === ROLES.ADMINISTRATOR_HOLDING_ID) && !scaduto && <li className="icon-box home" onClick={() => {
                          PAGESSWITCH.gotoPageWithParams(ROUTE.Companies);
                        }}>
                        <i className="fa icon-building-1 fa-4x" />
                        <a>
                          <h2>{LABEL_PAGE_Company[USERLANGUAGE]}</h2>
                        </a>
                      </li>}

                  {!scaduto && <li className="icon-box home" onClick={() => {
                          PAGESSWITCH.gotoPageWithParams(ROUTE.Fields);
                        }}>
                        <i className="fa icon-th-outline fa-4x" />
                        <a>
                          <h2>
                            {LABEL_PAGE_CustomFields[USERLANGUAGE]}
                          </h2>
                        </a>
                      </li>}

                  {!scaduto && <li className="icon-box home" onClick={() => {
                          PAGESSWITCH.gotoPageWithParams(ROUTE.Tables);
                        }}>
                        <i className="fa icon-table fa-4x" />
                        <a>
                          <h2>
                            {LABEL_PAGE_CustomTables[USERLANGUAGE]}
                          </h2>
                        </a>
                      </li>}

                  {//Gli amministratori sono visualizzabili solo da amministratore IS e holding
                  (this.state.role === ROLES.ADMINISTRATOR_IS_ID || this.state.role === ROLES.ADMINISTRATOR_HOLDING_ID) && !scaduto && <li className="icon-box home" onClick={() => {
                          PAGESSWITCH.gotoPageWithParams(ROUTE.Operators);
                        }}>
                        <i className="fa icon-users-yo fa-4x" />
                        <a>
                          <h2>{LABEL_PAGE_Operators[USERLANGUAGE]}</h2>
                        </a>
                      </li>}

                  {//Gli amministratori sono visualizzabili solo da amministratore IS e holding
                  (this.state.role === ROLES.ADMINISTRATOR_IS_ID || this.state.role === ROLES.ADMINISTRATOR_HOLDING_ID || this.state.role === ROLES.ADMINISTRATOR_AZIENDA_ID) && !scaduto && <li className="icon-box home" onClick={() => {
                          PAGESSWITCH.gotoPageWithParams(ROUTE.Printers);
                        }}>
                        <i className="fa icon-print fa-4x" />
                        <a>
                          <h2>{LABEL_PAGE_Printer[USERLANGUAGE]}</h2>
                        </a>
                      </li>}

                  {//Le aziende sono visualizzabili solo da amministratore IS e holding
                  this.state.role === ROLES.ADMINISTRATOR_IS_ID && !scaduto && <li className="icon-box home" onClick={() => {
                          PAGESSWITCH.gotoPageWithParams(ROUTE.Holding);
                        }}>
                        <i className="fa icon-book fa-4x" />
                        <a>
                          <h2>{LABEL_PAGE_Holding[USERLANGUAGE]}</h2>
                        </a>
                      </li>}

                  {<li className="icon-box home" onClick={() => {
                        PAGESSWITCH.gotoPageWithParams(ROUTE.Settings);
                      }}>
                      <i className="fa icon-cog fa-4x" />
                      <a>
                        <h2>{LABEL_PAGE_Settings[USERLANGUAGE]}</h2>
                      </a>
                    </li>}

                  <li className="icon-box home" onClick={() => {
                      this.props.dispatch(logout());
                    }}>
                    <i className="fa icon-exit-to-app-button fa-4x" />
                    <a>
                      <h2>{LABEL_Logout[USERLANGUAGE]}</h2>
                    </a>
                  </li>
                </ul>}
          </div>
        </div>;
  }

  
}

function mapStateToProps(state) {
  const { authenticationReducer } = state;
  const { isFetching, isAuthenticated } = authenticationReducer;
  return {
    isFetching,
    isAuthenticated
  };
}

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/Components/component_Menu.js